import styled, { keyframes } from 'styled-components';
import { palette, theme } from 'styled-tools';

import { Button, fontWeight, FontWeights, Text } from '@calm-web/design-system';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

export const Wrapper = styled.div<{
	isVisible: boolean;
}>`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: white;
	padding: 16px;
	opacity: ${p => (p.isVisible ? '1' : '0')};
	pointer-events: ${p => (p.isVisible ? '' : 'none')};
	transition: opacity ${theme('animation.transition')};
	z-index: ${p => theme('modal.zIndex')(p) - 1};
	text-align: center;
`;

export const Container = styled.div<{
	activeScreen: boolean;
}>`
	max-width: 560px;
	margin: auto;
	display: ${p => (p.activeScreen ? 'flex' : 'none')};
	flex-direction: column;
	margin-top: 64px;
`;

export const AuthContainer = styled(Container)`
	margin-top: 0;
`;

export const HeaderWrapper = styled.div`
	display: flex;
	align-items: baseline;
	justify-content: center;
	margin-bottom: 30px;
`;

export const HeaderText = styled(Text)`
	/* positioning tweaks for the inline logo */
	& > span {
		position: relative;
		top: 3px;
		margin: 0 3px !important;
	}
`;

export const CTAButton = styled(Button)`
	margin-top: 30px;
`;

export const Description = styled(Text)`
	padding-left: 50px;
	padding-right: 50px;
	margin-top: 8px;
`;

export const AuthHeading = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h4',
})`
	color: ${palette('gray7')};
	margin-top: 0;
	margin-bottom: 32px;
	${fontWeight(FontWeights.Regular)};
`;
